import { render } from "./CraftList.vue?vue&type=template&id=541a3e0e&scoped=true"
import script from "./CraftList.vue?vue&type=script&lang=js"
export * from "./CraftList.vue?vue&type=script&lang=js"

import "./CraftList.vue?vue&type=style&index=0&id=541a3e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541a3e0e"]])

export default __exports__